import { render, staticRenderFns } from "./Tunnel.vue?vue&type=template&id=70dd4308&"
import script from "./Tunnel.vue?vue&type=script&lang=js&"
export * from "./Tunnel.vue?vue&type=script&lang=js&"
import style0 from "./Tunnel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports